<!--
 - Manage Order - Header Component HTML
 -
 - @version
 - 4.73.0 OAUI-711 Rename Lookahead Orders as Spooling Orders
 - 4.71.0 OAUI-693 Tidy and remove duplicated code
 - 4.66.0 OAUI-665 Order Details shows unexpected "Ecommerce" in label
 - 4.63.0 DEVOPS-715 order-admin-ui: setup new repo without vertical slicing
 - 4.36.0 OAUI-521 Add support to only show new reports on details/work orders V2
 - 4.36.0 OAUI-508 Missing "Model Viewer" section/link on new order details page
 - 4.36.0 OAUI-518 Add order reports and exports
 - 4.36.0 OAUI-502 Edit order details
 - 4.35.0 OAUI-497 View order attachments
 - 4.35.0 OAUI-496 Add header and missing fields
 -
 - @author Ryan Sweeney <rsweeney@buildcentrix.com>
 - @copyright (c) 2022-2024 Build Centrix
 -->
<div class="manage-orders-header">
  <div class="row">
    <div class="left col-sm-12 col-md-4">
      <div
        class="bcx-buttons-container"
        [hidden]="wdManageOrdersService.isLoadingOrder.value === true"
      >
        <!--Takeoff Button-->
        <div class="mb-1" *ngIf="order.assembly?.link">
          <a href="{{order.assembly?.link}}" target="_blank">
            <bc-atoms-button
              id="btnAssembly"
              name="btnName"
              icon="view"
              display="block"
              label="{{'order.assembly.title'|translate}}"
              title="{{'order.assembly.description'|translate}}"
              size="small"
              type="default"
            >
            </bc-atoms-button>
          </a>
        </div>
        <!--View Model Button-->
        <div class="mb-1" *ngIf="order.isModelViewerEnabled">
          <bc-atoms-button
            id="btnModelViewer"
            name="btnModelViewer"
            icon="view"
            display="block"
            label="{{'actions.viewType'|translate: { type: ('order.model.title'|translate )} }}"
            title="{{'actions.viewType'|translate: { type: ('order.model.description'|translate)} }}"
            size="small"
            type="default"
            (onButtonClicked)="navigateToModelViewer(order)"
          >
          </bc-atoms-button>
        </div>
      </div>
    </div>
    <div class="center col-sm-12 col-md-4">
      <!--Page Title-->
      <div class="title">
        <!--Main Title-->
        <div class="main">
          <!--Ecommerce Title-->
          <span *ngIf="order.isEcommerce">Ecommerce </span>
          <!--Spooling Title-->
          <span *ngIf="order.isLookahead">Spooling </span>
          <!--Work Title-->
          <span *ngIf="!order.isLookahead && !order.isEcommerce">Work </span>
          <!--Order Title-->
          <span>{{orderTitle}}</span>
        </div>

        <!--Loading Icon-->
        <div
          class="sub"
          *ngIf="wdManageOrdersService.isReloadingOrder.value===true"
        >
          <span class="icon">
            <bc-atoms-icon [type]="'loading'" [rotate]="true"></bc-atoms-icon>
          </span>
          {{'actions.loading'|translate}} {{'order.title.singular'|translate}}
        </div>

        <!--Subtitle-->
        <div
          class="sub"
          *ngIf="wdManageOrdersService.isReloadingOrder.value===false"
        >
          {{orderSubtitle}}
        </div>
      </div>
    </div>
    <div class="right col-sm-12 col-md-4">
      <div
        class="bcx-buttons-container"
        [hidden]="wdManageOrdersService.isLoadingOrder.value === true"
      >
        <!--Exports -->
        <div class="exports-button" *ngIf="true">
          <div class="input-container">
            <bc-atoms-button
              label="{{'exports.title'|translate }}"
              title="{{'exports.description'|translate }}"
              icon="export"
              display="block"
              size="small"
              [disabled]="false"
            >
              <div dropdown-content>
                <form class="m-2">
                  <!--Reports-->
                  <bc-atoms-input-group
                    *ngIf="order?.reports?.length > 0"
                    labelIcon="all"
                    labelTitle="{{'exports.reports.title'|translate}}"
                    labelDescription="{{'exports.reports.description'|translate}}"
                  >
                    <div
                      class="dropdown-item"
                      *ngFor="let reportElem of order?.reports"
                    >
                      <a [href]="reportElem.url" [target]="reportElem.target">
                        <bc-atoms-icon [type]="reportElem.icon"></bc-atoms-icon>
                        <label>{{reportElem.label}}</label>
                      </a>
                    </div>
                  </bc-atoms-input-group>

                  <!--Exports-->
                  <bc-atoms-input-group
                    *ngIf="order?.exports?.length > 0"
                    labelIcon="all"
                    labelTitle="{{'exports.title'|translate}}"
                    labelDescription="{{'exports.description'|translate}}"
                  >
                    <div
                      class="dropdown-item"
                      *ngFor="let exportElem of order.exports"
                    >
                      <a [href]="exportElem.url" [target]="exportElem.target">
                        <bc-atoms-icon [type]="exportElem.icon"></bc-atoms-icon>
                        <label>{{exportElem.label}}</label>
                      </a>
                    </div>
                  </bc-atoms-input-group>

                  <!--Downloads (CAM export, etc.)-->
                  <bc-atoms-input-group
                    *ngIf="order?.downloads?.length > 0"
                    labelIcon="all"
                    labelTitle="{{'exports.downloads.title'|translate}}"
                    labelDescription="{{'exports.downloads.description'|translate}}"
                  >
                    <div
                      class="dropdown-item"
                      *ngFor="let downloadElem of order.downloads"
                    >
                      <a
                        [href]="downloadElem.url"
                        [target]="downloadElem.target"
                      >
                        <bc-atoms-icon
                          [type]="downloadElem.icon"
                        ></bc-atoms-icon>
                        <label>{{downloadElem.label}}</label>
                      </a>
                    </div>
                  </bc-atoms-input-group>
                </form>
              </div>
            </bc-atoms-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
